import { useRef } from "react";

const useStateRef = (init) => {
    const ref = useRef(init);
    const setState = v => {
        ref.current = v;
    }
    const setter = useRef(setState).current;
    const getter = ref.current;
    return [getter, setter];
}

export default useStateRef;